export default {
  'financial.dre.form.planAccount': 'Account Plan',
};
